import AuditLogColumnFilterBodyNote from './AuditLogColumnFilterBodyNote';

export default AuditLogColumnFilterBodyNote;
